import { ajax } from '../utils/ajax'
import { defineStore } from 'pinia'
import isEmpty from 'lodash/isEmpty'

export const useWikiStore = defineStore('wiki', {
  state: () => ({
    articles: [],
    tags: {},
    history: [],
    displayedArticle: undefined,
  }),
  getters: {
    getArticles(state) {
      return state.articles
    },
    getTags(state) {
      return state.tags
    },
    isOpen() {
      return !!this.displayedArticle
    },
  },
  actions: {
    async fetch(force) {
      if (!isEmpty(this.articles) && !force) {
        return
      }

      const res = await ajax({ url: '/wiki_content' })
      this.articles = res.data.articles
      this.tags = res.data.tags
    },
    showArticle(permalink) {
      this.displayedArticle = this.articles.find(article => article.perma_link === permalink)
      this.history.push(permalink)
    },
    resetDisplayedArticle() {
      this.displayedArticle = undefined
      this.history = []
    },
    navigateBack() {
      this.displayedArticle = this.articles.find(
        article => article.perma_link === this.history[this.history.length - 2]
      )
      this.history.pop()
    },

    checkArticle(permalink) {
      return this.articles.some(article => article.perma_link === permalink && article.is_published)
    },
  },
})
